export const selectPreviousTicketSorting = state => state.tickets.previousSortBy

export const selectTicketSorting = state => state.tickets.sortBy
